/* tslint:disable */
/* eslint-disable */
/**
 * Example API
 * API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Order
 */
export interface Order {
    /**
     * Unique identifier for the order
     * @type {string}
     * @memberof Order
     */
    readonly id: string;
    /**
     * Number of credits purchased in this order
     * @type {number}
     * @memberof Order
     */
    credits: number;
    /**
     * Amount paid for the order
     * @type {number}
     * @memberof Order
     */
    amount: number;
    /**
     * Currency of the payment
     * @type {string}
     * @memberof Order
     */
    currency: string;
    /**
     * Status of the order
     * @type {string}
     * @memberof Order
     */
    status: string;
    /**
     * Stripe checkout URL for the order
     * @type {string}
     * @memberof Order
     */
    stripeCheckoutUrl: string;
    /**
     * Stripe session ID for the order
     * @type {string}
     * @memberof Order
     */
    stripeSessionId: string;
    /**
     * Timestamp when the order was created
     * @type {Date}
     * @memberof Order
     */
    readonly createdAt: Date;
    /**
     * ID of the account that placed the order
     * @type {string}
     * @memberof Order
     */
    readonly accountId: string;
}

/**
 * Check if a given object implements the Order interface.
 */
export function instanceOfOrder(value: object): value is Order {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('credits' in value) || value['credits'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('stripeCheckoutUrl' in value) || value['stripeCheckoutUrl'] === undefined) return false;
    if (!('stripeSessionId' in value) || value['stripeSessionId'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('accountId' in value) || value['accountId'] === undefined) return false;
    return true;
}

export function OrderFromJSON(json: any): Order {
    return OrderFromJSONTyped(json, false);
}

export function OrderFromJSONTyped(json: any, ignoreDiscriminator: boolean): Order {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'credits': json['credits'],
        'amount': json['amount'],
        'currency': json['currency'],
        'status': json['status'],
        'stripeCheckoutUrl': json['stripeCheckoutUrl'],
        'stripeSessionId': json['stripeSessionId'],
        'createdAt': (new Date(json['createdAt'])),
        'accountId': json['accountId'],
    };
}

  export function OrderToJSON(json: any): Order {
      return OrderToJSONTyped(json, false);
  }

  export function OrderToJSONTyped(value?: Omit<Order, 'id'|'createdAt'|'accountId'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'credits': value['credits'],
        'amount': value['amount'],
        'currency': value['currency'],
        'status': value['status'],
        'stripeCheckoutUrl': value['stripeCheckoutUrl'],
        'stripeSessionId': value['stripeSessionId'],
    };
}

